import script from "./ChatApp.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatApp.vue?vue&type=script&setup=true&lang=js"

import "./ChatApp.vue?vue&type=style&index=0&id=224275ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-224275ce"]])

export default __exports__